import { Injectable } from '@angular/core';

import { AppConfigurationService } from 'shared/app-configuration';

import { UnsubscribeApiPaths } from './unsubscribe.paths.api';

@Injectable()
export class UnsubscribeConfiguration {
    apiPaths: UnsubscribeApiPaths;

    constructor(private readonly appConfiguration: AppConfigurationService) {
        this.apiPaths = new UnsubscribeApiPaths(this.appConfiguration.configuration.uris.unsubscribeService);
    }
}
